module.exports = __webpack_public_path__ + "img/question.fe730bce.svg";